import { useRouteError } from 'react-router-dom';
import { ErrorFallback } from '@/components/ErrorFallback';

export function RouteErrorElement() {
  const error = useRouteError() as Error;
  return (
    <ErrorFallback
      error={error}
      resetErrorBoundary={() => window.location.reload()}
    />
  );
}
